






































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import * as Reveal from '@/assets/scripts/RevealOnScrollModule'

@Component
export default class RevealOnScroll extends Vue {
	data() {
		return {
			PageTitle: "Reveal on scroll"
		}
	}
	mounted() {
		new Reveal.revealOnScrollModule()
	}
}
